import React from "react";
import { createPopper } from "@popperjs/core";
import truncateEthAddress from 'truncate-eth-address'
// components
import { connectWallet,getProvider } from "./../Navbars/WalletConnector";

const UserDropdown = () => {
  const [text,setText] = React.useState("Connect Wallet");
  const confirmSignIn = async () => {
    const provider = await getProvider();
    const account = await provider.listAccounts();

    if(account[0]){
      setText(truncateEthAddress(account[0]));
    }
   console.log(text)
  }
  confirmSignIn()
   return (
    <>
      <button
                onClick={connectWallet}
                  className="bg-lightBlue-500 text-white active:bg-lightBlue-600 text-xs font-bold uppercase px-0 py-2 rounded "
                  type="button"
                >
                  <i className="fas my-Font fa-arrow-alt-circle-down"></i> {text}
                </button>
    </>
  );
};

export default UserDropdown;
